import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SnippetsFilledSvg from "@ant-design/icons-svg/es/asn/SnippetsFilled";
import AntdIcon from "../components/AntdIcon";
var SnippetsFilled = function SnippetsFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SnippetsFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SnippetsFilled.displayName = 'SnippetsFilled';
}
export default /*#__PURE__*/React.forwardRef(SnippetsFilled);